import axios from "axios";
import axiosRetry from "axios-retry";
import Notification from "./Notification";
import { withRouter } from "react-router-dom";
import { API_VERSION } from "env.json";
import { connect } from "react-redux";
import { logout } from "actions/login";
import { store } from "App";
import { setNotificationVisible } from "actions/layout";


let _TIMER = null;
const _REQUESTS = {};
let _REQUEST_SEQ = 0;
let _LOGGING_OUT = false;
let _LOGOUT_TIMER = null;
let _LOGOUT_MESSAGE = "Your access has changed. Please log in again.";
let _LOGOUT_REASON = null;

function scheduleForcedLogout(specificMessage, reason) {
  if (specificMessage) {
    _LOGOUT_MESSAGE = specificMessage;
  }
  if (!_LOGOUT_REASON) {
    _LOGOUT_REASON = reason;
  }
  if (_LOGGING_OUT || _LOGOUT_TIMER) {
    return;
  }

  _LOGOUT_TIMER = setTimeout(() => {
    _LOGGING_OUT = true;
    const { authenticated } = store.getState()["session"];
    if (authenticated) {

      sessionStorage.setItem("postLogoutNotice", JSON.stringify({
        title: "Session Expired",
        message: _LOGOUT_MESSAGE,
        reasonType: _LOGOUT_REASON?.type
      }));
    }

    const hardRedirectHistory = {
      push: () => {
        setTimeout(() => {
          window.location.href = "/login";
        }, 800);
      }
    };
    logout(hardRedirectHistory, _LOGOUT_REASON)(store.dispatch, store.getState);
  }, 200);
}

class Api {
  constructor() {
    this.orgHeader(process.env.REACT_APP_ORG_URL || window.location.hostname);
    axiosRetry(axios, {
      retries: 3,
      retryDelay: (retryCount) => {
        console.log(`retry attempt: ${retryCount}`);
        return retryCount * 1000;
      },
      retryCondition: (error) => error?.response?.status === 504,
    });
  }

  _url = "/";
  _base_url = "";
  _s3_url = "https://s3.ap-south-1.amazonaws.com/prod.files.classroom.digital-0949/";
  dlS3Url = "https://prod-digital-library-0949.s3.ap-south-1.amazonaws.com/";
  proDlS3Url = "https://s3.ap-south-1.amazonaws.com/prod-digital-library-0949/"
  hlsUrl = "https://hls-stream.aulas.in/"

  _method = "get";
  _params = {};
  _suppressSnackbar = false;
  _headers = {
    Authorization: "",
    version: API_VERSION,
    orgurl: "",
    // 'ngrok-skip-browser-warning': "hey"
  };

  suppressSnackbar(value = true) {
    this._suppressSnackbar = value;
    return this;
  }


  suppressLogout(value = true) {
    this._suppressLogout = value;
    return this;
  }

  get(url, params = {}, options = {}) {
    this._url = url;
    this._method = "get";
    this._middleUrl = "/api";
    this._params = params;
    if (options.silent) this._suppressSnackbar = true;
    return this;
  }

  post(url, params = {}, options = {}) {
    this._url = url;
    this._method = "post";
    this._middleUrl = "/api";
    this._params = params;
    // silent hides this request's toasts; send() clears the flag after each request
    if (options.silent) this._suppressSnackbar = true;
    return this;
  }

  delete(url, params = {}, options = {}) {
    this._url = url;
    this._method = "delete";
    this._middleUrl = "/api";
    this._params = params;
    if (options.silent) this._suppressSnackbar = true;
    return this;
  }
  patch(url, params = {}, options = {}) {
    this._url = url;
    this._method = "patch";
    this._middleUrl = "/api";
    this._params = params;
    if (options.silent) this._suppressSnackbar = true;
    return this;
  }

  params(params) {
    this._params = params;
    return this;
  }

  header(value) {
    this._headers["Authorization"] = `Bearer ${value}`;
  }

  orgHeader(value) {
    this._headers["orgurl"] = `${value}`;
    this._base_url = `https://${this._headers["orgurl"]}`;
  }

  send(callback, timed = false) {
    _REQUEST_SEQ += 1;
    let requestKey = `${this._url}#${_REQUEST_SEQ}`;
    try {
      requestKey = `${this._url}_${JSON.stringify(this._params)}#${_REQUEST_SEQ}`;
    } catch (e) {
      // fallback
    }
    _REQUESTS[requestKey] = {
      _url: this._url,
      _base_url: this._base_url,
      _method: this._method,
      _params: this._params,
      _middleUrl: this._middleUrl,
      _headers: this._headers,
      _suppressSnackbar: this._suppressSnackbar,
      _suppressLogout: this._suppressLogout,
      callback,
    };

    this._suppressSnackbar = false;
    this._suppressLogout = false;

    const _self = this;
    if (timed) {
      _self.processApiRequest();
    } else {
      clearTimeout(_TIMER);
      _TIMER = setTimeout(() => {
        _self.processApiRequest();
      }, 50);
    }
  }

  processApiRequest() {
    const _keys = Object.keys(_REQUESTS);
    if (!_keys.length) {
      return;
    }

    const _self = _REQUESTS[_keys[0]];
    delete _REQUESTS[_keys[0]];
    _self.processApiRequest = this.processApiRequest;

    const request = {
      method: _self._method,
      headers: _self._headers,
      timeout: _self._timeout,
      url: `${_self._base_url}${_self._middleUrl}${_self._url}`,
    };

    const { authenticated, user } = store.getState()["session"];
    if (authenticated && user?.accessToken) {
      _self._headers.Authorization = `Bearer ${user.accessToken}`;
    }

    if (_self._method === "post" || _self._method === "patch") {
      request.data = _self._params;
    } else if (_self._method === "get" || _self._method === "delete") {
      request.params = _self._params;
      if (_self._method === "get") {
        request.headers = {
          ...request.headers,
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
        };
      }
    }
    console.log("APi req", request);
    axios(request)
      .then((response, error) => {
        console.log("APi res", response);
        if (typeof response !== "undefined" && response.data && response.data.show && !_self._suppressSnackbar) {
          if (response.data.show.popup) {
            store.dispatch(setNotificationVisible(true, response.data.show.type,
              response.data.show.message.title,
              response.data.show.message.description));
          } else {
            Notification[response.data.show.type](
              response.data.show.type,
              response.data.show.message
            );
          }

        }
        _self.processApiRequest();
        _self.callback(response.data, error);
      })
      .catch((error, response) => {
        let shouldLogout = false;
        let logoutReason = null;
        let rawMessage = null;
        let isPopup = false;
        let specificLogoutMessage = null;

        if (typeof error.response !== "undefined") {
          let looksLikeServerCrash = false;
          if (error.response.data && error.response.data.show) {
            rawMessage = error.response.data.show.message;
            isPopup = !!error.response.data.show.popup;
            const messageText = typeof rawMessage === "string" ? rawMessage : "";
            looksLikeServerCrash = /cannot read propert(y|ies)|undefined is not a function|is not a function|null is not an object|is not defined|TypeError/i.test(messageText);
            const looksUnauthorized = /unauthori[sz]|forbidden|no.*(access|permission)|permission.*denied/i.test(messageText);

            if (looksUnauthorized && !looksLikeServerCrash) {
              shouldLogout = true;
              logoutReason = rawMessage;
            }
            if (error.response.data.show.logout && !looksLikeServerCrash) {
              shouldLogout = true;
              logoutReason = rawMessage;
              if (messageText) {
                specificLogoutMessage = messageText;
              }
            }
          }
          if ((error.response.status == 401 || error.response.status == 403) && !looksLikeServerCrash) {
            shouldLogout = true;
            logoutReason = "Unauthorized";
          }
        }

        if (shouldLogout && _self._url !== '/login/generateOtp' && !_self._suppressLogout) {
          const { user, authenticated } = store.getState()["session"];

          const isStudentAssignmentChange =
            authenticated &&
            user?.role?.includes("Student") &&
            /role\s*\/?\s*privilege|assignment/i.test(specificLogoutMessage || logoutReason || "");
          if (isStudentAssignmentChange) {
            if (window.location.pathname !== "/home") {
              window.location.href = "/home";
            }
          } else {
            scheduleForcedLogout(specificLogoutMessage, {
              type: logoutReason,
              endPoint: _self._url,
              method: _self._method
            });
          }
        } else if (rawMessage && !shouldLogout) {
          if (isPopup) {
            store.dispatch(setNotificationVisible(true, error?.response?.data?.show?.type,
              rawMessage.title,
              rawMessage.description));
          } else if (!_self._suppressSnackbar) {
            Notification.error("Error", rawMessage);
          }
        }

        _self.processApiRequest();
        _self.callback(response, error?.response?.data);
      });
  }

  uploadMultiple(params, callback) {
    console.log({ params })
    const headers = this._headers;
    headers["Content-Type"] = "multipart/form-data";
    // eslint-disable-next-line no-undef
    const form = new FormData();

    if (params.files) {
      params.files.forEach((file) => {
        form.append("files", file);
      });
    }

    if (params.images) {
      params.images.forEach((image) => {
        form.append('images', image)
      })
    }

    for (const param in params) {
      console.log(param, 'param')
      const element = params[param];
      if (param !== "files" && param !== "images" && !Array.isArray(element)) {
        form.append(param, params[param]);
      } else if (param !== "files" && param !== "images" && Array.isArray(element)) {
        // let index1 = 0;
        // for (const item of element) {
        //   if (item != null) {
        //     form.append(`${param}[${index1}]`, item);
        //   }
        //   index1++
        // }
        let index = 0;
        for (const item of element) {
          if (Object.keys(item)?.length > 0 && typeof item === 'object' && !Array.isArray(item) && item !== null) {
            const itemKeys = Object.keys(item);
            console.log({ item })
            itemKeys.forEach((temp1, tIndex) => {
              if (item[temp1] != null) {
                const X = item[temp1];
                console.log(X, 'this is some x')
                if (Array.isArray(X)) {
                  let index2 = 0;
                  for (const ele of X) {
                    if (ele && (Object.keys(ele)?.length > 0)) {
                      const eleKeys = Object.keys(ele);
                      console.log(eleKeys, 'this is x')
                      eleKeys.forEach((temp2, tIndex) => {
                        if (ele[temp2] != null) {
                          form.append(`${param}[${index}][${temp1}][${index2}][${temp2}]`, ele[temp2]);
                        }
                      })
                    }
                    index2++
                  }
                } else {
                  form.append(`${param}[${index}][${temp1}]`, item[temp1]);
                }
              }
            })
          } else {
            form.append(`${param}[${index}]`, item);
          }
          index++;
        }
      }
    }

    const config = {
      headers,
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        callback(percentCompleted);
      },
    };

    axios
      .post(this._base_url + "/api" + this._url, form, config)
      .then((response) => {
        if (typeof response !== "undefined" && response.data.show) {
          if (response.data.show.popup) {
            store.dispatch(setNotificationVisible(true, response.data.show.type,
              response.data.show.message.title,
              response.data.show.message.description));
          } else {
            Notification[response.data.show.type](
              response.data.show.type,
              response.data.show.message
            );
          }
        }
        if (
          typeof response !== "undefined" &&
          response.data.show &&
          response.data.show.type === "error"
        ) {
          callback(-1);
        }
        callback(100, response);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined" && error.response.data.show) {
          Notification.error("Error", error.response.data.show.message);
        }
        callback(-1);
      });

    this._headers["Content-Type"] = "application/json";
  }

  upload(params, callback, cancelToken) {
    const headers = this._headers;
    // Read before the await-free setup below hands control back and another
    // caller can flip it, and reset like send() does.
    const suppressSnackbar = this._suppressSnackbar;
    this._suppressSnackbar = false;
    headers["Content-Type"] = "multipart/form-data";
    // eslint-disable-next-line no-undef
    const form = new FormData();

    if (params.files) {
      params.files.forEach((file) => {
        form.append("files", file);
      });
    }
    for (const param in params) {
      if (param !== "files") {
        form.append(param, params[param]);
      }
    }

    const config = {
      headers,
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        callback(percentCompleted);
      },
    };
    if (cancelToken) {
      config.cancelToken = cancelToken;
    }

    axios
      .post(this._base_url + "/api" + this._url, form, config)
      .then((response) => {
        // suppressSnackbar used to be honoured only in the catch below, so a caller that
        // asked for silence still got the backend's success toast. A caller that reports
        // the outcome itself wants neither half of that.
        if (!suppressSnackbar && typeof response !== "undefined" && response?.data?.show) {
          if (response.data.show.popup) {
            store.dispatch(setNotificationVisible(true, response.data.show.type,
              response.data.show.message.title,
              response.data.show.message.description));
          } else {
            Notification[response.data.show.type](
              response.data.show.type,
              response.data.show.message
            );
          }
        }
        if (
          typeof response !== "undefined" &&
          response?.data?.show &&
          response?.data?.show?.type === "error"
        ) {
          callback(-1);
        }
        callback(100, response);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return;
        }
        if (
          !suppressSnackbar &&
          typeof error.response !== "undefined" &&
          error.response.data.show
        ) {
          Notification.error("Error", error.response.data.show.message);
        }
        callback(-1);
      });

    this._headers["Content-Type"] = "application/json";
  }

  uploadAndPatch(params, callback) {
    const headers = this._headers;

    const form = new FormData();
    // for (var param in params) {
    //   form.append(param, params[param]);
    // }
    for (var param in params) {
      if (Array.isArray(params[param])) {
        form.append(param, JSON.stringify(params[param]));
      } else {
        form.append(param, params[param]);
      }
    }
    headers["Content-Type"] = `multipart/form-data;boundary=${form._boundary}`;

    const config = {
      headers,
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        callback(percentCompleted);
      },
    };

    axios
      .patch(this._base_url + "/api" + this._url, form, config)
      .then((response) => {
        if (typeof response !== "undefined" && response.data && response.data.show) {
          if (response.data.show.popup) {
            store.dispatch(setNotificationVisible(true, response.data.show.type,
              response.data.show.message.title,
              response.data.show.message.description));
          } else {
            Notification[response.data.show.type](
              response.data.show.type,
              response.data.show.message
            );
          }
          if (
            typeof response !== "undefined" &&
            response.data.show &&
            response.data.show.type === "error"
          ) {
            callback(-1);
          }
        }
        callback(100, response);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined" && error.response.data && error.response.data.show) {
          Notification.error("Error", error.response.data.show.message);
        }
        callback(-1);
      });

    this._headers["Content-Type"] = "application/json";
  }

  uploadAndPost(_url = null, params, callback) {
    const headers = this._headers;
    const form = new FormData();
    // for (var param in params) {
    //   form.append(param, params[param])
    // }
    for (var param in params) {
      if (Array.isArray(params[param])) {
        form.append(param, JSON.stringify(params[param]));
      } else {
        form.append(param, params[param]);
      }
    }
    headers["Content-Type"] = `multipart/form-data;boundary=${form._boundary}`;
    const config = {
      headers,
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        callback(percentCompleted);
      },
    };

    axios
      .post(this._base_url + "/api" + _url, form, config)
      .then((response) => {
        if (typeof response !== "undefined" && response.data && response.data.show) {
          if (response.data.show.popup) {
            store.dispatch(setNotificationVisible(true, response.data.show.type,
              response.data.show.message.title,
              response.data.show.message.description));
          } else {
            Notification[response.data.show.type](
              response.data.show.type,
              response.data.show.message
            );
          }
          if (
            typeof response !== "undefined" &&
            response.data.show &&
            response.data.show.type === "error"
          ) {
            callback(-1);
          }
        }
        callback(100, response);
      })
      .catch((error) => {
        if (typeof error.response !== "undefined" && error.response.data && error.response.data.show) {
          Notification.error("Error", error.response.data.show.message);
        }
        callback(-1, undefined, error?.response);
      });

    this._headers["Content-Type"] = "application/json";
  }
}

const ApiClass = new Api();

export default withRouter(ApiClass);